// extracted by mini-css-extract-plugin
export var black = "_2f-6";
export var brand = "_2f-1";
export var ddefault = "_2f-0";
export var error = "_2f-3";
export var gray = "_2f-2";
export var highContrast = "_2f-8";
export var outline = "_2f-7";
export var success = "_2f-5";
export var warning = "_2f-4";